import React from 'react';
import { Icon } from './icons.jsx';
// Tela de Login do Painel Admin E-commerce
const LoginPage = ({ onLogin, initialError = '' }) => {
  const [email, setEmail]       = React.useState('');
  const [password, setPassword] = React.useState('');
  const [showPwd, setShowPwd]   = React.useState(false);
  const [error, setError]       = React.useState(initialError);
  const [loading, setLoading]   = React.useState(false);
  const [forgotSent, setForgotSent] = React.useState(false);

  React.useEffect(() => {
    setError(initialError || '');
  }, [initialError]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) { setError('Preencha e-mail e senha.'); return; }
    setError('');
    setLoading(true);
    try {
      await onLogin({ email: email.trim(), password });
    } catch (err) {
      if (err?.status === 401) {
        setError('E-mail ou senha inválidos.');
      } else if (err?.status === 403) {
        setError('Seu usuário não tem permissão para acessar o Super Admin.');
      } else {
        setError('Não foi possível conectar ao servidor.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleForgot = (e) => {
    e.preventDefault();
    if (!email.trim()) { setError('Digite seu e-mail para recuperar a senha.'); return; }
    setForgotSent(true);
    setTimeout(() => setForgotSent(false), 4000);
  };

  const inputStyle = {
    width: '100%', height: 40, padding: '0 12px',
    borderRadius: 'var(--radius)', border: '1px solid var(--border-strong)',
    background: 'var(--bg-elevated)', color: 'var(--text)',
    fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box',
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-subtle)', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 380, background: 'var(--bg-elevated)', borderRadius: 'var(--radius-xl)', boxShadow: 'var(--shadow-lg)', padding: '40px 36px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="assets/tezus-logo.svg" alt="Vitrine" style={{ height: 28, marginBottom: 10 }} />
          <div style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--text-muted)' }}>
            Painel Admin
          </div>
        </div>

        <form onSubmit={handleSubmit} noValidate="">
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 6 }}>
              E-mail
            </label>
            <input
              type="email"
              value={email}
              onChange={e => { setEmail(e.target.value); setError(''); }}
              placeholder="julio@tezus.com"
              style={inputStyle}
              autoComplete="email"
              disabled={loading}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)', marginBottom: 6 }}>
              Senha
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPwd ? 'text' : 'password'}
                value={password}
                onChange={e => { setPassword(e.target.value); setError(''); }}
                placeholder="••••••••"
                style={{ ...inputStyle, paddingRight: 80 }}
                autoComplete="current-password"
                disabled={loading}
              />
              <button
                type="button"
                onClick={() => setShowPwd(v => !v)}
                style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', padding: '2px 6px', letterSpacing: '0.02em' }}
              >
                {showPwd ? 'Ocultar' : 'Mostrar'}
              </button>
            </div>
          </div>

          {error && (
            <div style={{ fontSize: 13, color: 'var(--danger)', background: 'var(--danger-bg)', borderRadius: 'var(--radius)', padding: '8px 12px', marginBottom: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
              <Icon name="alert" size={13} style={{ flexShrink: 0 }} />
              {error}
            </div>
          )}

          {forgotSent && (
            <div style={{ fontSize: 13, color: 'var(--info)', background: 'var(--info-bg)', borderRadius: 'var(--radius)', padding: '8px 12px', marginBottom: 14 }}>
              Link de recuperação enviado para <strong>{email}</strong>.
            </div>
          )}

          <button
            type="submit"
            className="btn primary"
            disabled={loading}
            style={{ width: '100%', justifyContent: 'center', height: 42, fontSize: 14, fontWeight: 600, marginBottom: 14 }}
          >
            {loading ? 'Verificando…' : 'Entrar'}
          </button>

          <div style={{ textAlign: 'center' }}>
            <a
              href="#"
              onClick={handleForgot}
              style={{ fontSize: 13, color: 'var(--text-muted)', textDecoration: 'none' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--text)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--text-muted)'}
            >
              Esqueci minha senha
            </a>
          </div>
        </form>
      </div>
    </div>
  );
};

export {
  LoginPage,
};
